import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utlilites/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  companies: [],

};


const slice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET spell
    getCompanysuccess(state, action) {
      console.log(state.subadmins,"subadmins")
      state.isLoading = false;
      state.companies = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;


// ----------------------------------------------------------------------

export function getCompany() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      await axiosInstance.get(`all/admin/company`).then((response) => {
        console.log(response, 'company--->>>>')
        dispatch(slice.actions.getCompanysuccess(response?.data?.company));
      })
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------